import { useEffect, useRef,useState} from "react";
import {
    getToken,
    getUserId,
    getLingua,
    getInizioPIstr,
    setInizioPIstr,
    setFinePIstr,
    getFinePIstr, getInizioPeriodo
} from "../auth";
import funzione_collegamento from "../funzioni_server/pacchetti_lez_function.js";
import  differenzaOrario  from "../funzioni/differenza_ore";
import "../stili/tabelle.css";
import "../stili/popup.css";
import "../stili/tabs.css"
import "../stili/agenda.css"
import convertDate from "../funzioni/converti_data";
import { DateTime } from 'luxon';
import nome_id from "../funzioni/nome_id.js"
import {convertiIdInventario,ordinaPerData,prendiNomePacchetto,coloreDaId,pacchettiAperti,materialeDisponibile,istruttori_disponibili,isoToString} from "../funzioni/funzioni_utili"
import ReactDOM from "react-dom/client";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faUsers, faPencil, faTrashCan,faCircleInfo,faSpinner } from "@fortawesome/free-solid-svg-icons";
import Lottie from "lottie-react";
import animLoading from "../assets/loading.json";
import status_lezione from "../funzioni/status_lezione"
import { RRule, rrulestr } from 'rrule';
/* global $ */

function AnalisiIstruttore(){
    const [isMobile, setIsMobile] = useState(window.innerWidth < 600);
    let inizioModIn1
    let inizioModIn2
    let fineModIn1
    let fineModIn2
    let entratePeriodi={1:{},2:{},3:{}}
    let dataSourceOre=[]
    let dataSourceGuadagno=[]
    const localizzazioniNumeriche = {
  "1": "it-IT", // Italiano
  "2": "en-US", // Inglese
  "3": "de-DE", // Tedesco
  "4": "es-ES"  // Spagnolo
};
    const localizzazioniDate = {
  "1": "it", // Italiano
  "2": "en", // Inglese
  "3": "de", // Tedesco
  "4": "es"  // Spagnolo
};
    const traduzioni = {
        "settimana": {
  "1": "Settimana del",
  "2": "Week of",
  "3": "Woche vom",
  "4": "Semana del"
},
          "valore": {
    "1": "Valore",
    "2": "Value",
    "3": "Wert",
    "4": "Valor"
  },
        "categoria": {
    "1": "Categoria",
    "2": "Category",
    "3": "Kategorie",
    "4": "Categoría"
  },
  "riferimento": {
    "1": "Riferimento",
    "2": "Reference",
    "3": "Referenz",
    "4": "Referencia"
  },
  "percentuale": {
    "1": "Percentuale",
    "2": "Percentage",
    "3": "Prozentsatz",
    "4": "Porcentaje"
  },
  "titolo": {
    "1": "Analisi guadagni",
    "2": "Earnings analysis",
    "3": "Gewinnanalyse",
    "4": "Análisis de ganancias"
  },
  "inizioPeriodo": {
    "1": "Inizio periodo",
    "2": "Period start",
    "3": "Periodenbeginn",
    "4": "Inicio del período"
  },
  "finePeriodo": {
    "1": "Fine periodo",
    "2": "Period end",
    "3": "Periodenende",
    "4": "Fin del período"
  },
  "andamento_mensile": {
    "1": "Andamento mensile",
    "2": "Monthly trend",
    "3": "Monatlicher Verlauf",
    "4": "Tendencia mensual"
  },
  "andamento_settimanale": {
    "1": "Andamento settimanale",
    "2": "Weekly trend",
    "3": "Wöchentlicher Verlauf",
    "4": "Tendencia semanal"
  },
  "andamento_giornaliero": {
    "1": "Andamento giornaliero",
    "2": "Daily trend",
    "3": "Täglicher Verlauf",
    "4": "Tendencia diaria"
  },
        "oreTotali": {
  "1": "Ore totali",
  "2": "Total hours",
  "3": "Gesamtstunden",
  "4": "Horas totales"
},
  "guadagno_totale": {
    "1": "Guadagno totale",
    "2": "Total earnings",
    "3": "Gesamtgewinn",
    "4": "Ganancia total"
  },
  "guadagno_per_studente": {
    "1": "Guadagno per studente",
    "2": "Earnings per student",
    "3": "Gewinn pro Schüler",
    "4": "Ganancia por estudiante"
  },
  "ore_per_studente": {
    "1": "Ore per studente",
    "2": "Hours per student",
    "3": "Stunden pro Schüler",
    "4": "Horas por estudiante"
  },
  "divisione_mensile": {
    "1": "Divisione mensile",
    "2": "Monthly breakdown",
    "3": "Monatliche Aufteilung",
    "4": "División mensual"
  },
  "divisione_settimanale": {
    "1": "Divisione settimanale",
    "2": "Weekly breakdown",
    "3": "Wöchentliche Aufteilung",
    "4": "División semanal"
  },
  "divisione_giornaliera": {
    "1": "Divisione giornaliera",
    "2": "Daily breakdown",
    "3": "Tägliche Aufteilung",
    "4": "División diaria"
  },
  "entrate": {
    "1": "Entrate",
    "2": "Income",
    "3": "Einnahmen",
    "4": "Ingresos"
  },
  "suddivisione_entrate": {
    "1": "Suddivisione delle entrate",
    "2": "Income breakdown",
    "3": "Aufschlüsselung der Einnahmen",
    "4": "Desglose de ingresos"
  }
};

    useEffect(()=>{
        const datebox=$("#dateboxperiodo").dxDateRangeBox({
            displayFormat: "dd/MM/yyyy",
            startDateLabel: traduzioni["inizioPeriodo"][getLingua()],
            endDateLabel: traduzioni["finePeriodo"][getLingua()],
            showClearButton: true,
            openOnFieldClick: true,

            startDate: getInizioPIstr() ? new Date(getInizioPIstr()) : new Date(2025, 11, 15),
            endDate: getFinePIstr() ? new Date(getFinePIstr()) : new Date(2026, 3, 1),
            onValueChanged:function(e){
                setInizioPIstr(DateTime.fromJSDate(e.value[0]).toISO())
                setFinePIstr(DateTime.fromJSDate(e.value[1]).toISO())
            },
            onFocusOut: function(e){
            fineModIn1= $("#dateboxperiodo").dxDateRangeBox("instance").option("startDate")
            fineModIn2= $("#dateboxperiodo").dxDateRangeBox("instance").option("endDate")
            if (inizioModIn1!==fineModIn1 ||inizioModIn2!==fineModIn2){
                window.location.reload()
            }
        },
        onFocusIn: function(e){
            inizioModIn1= $("#dateboxperiodo").dxDateRangeBox("instance").option("startDate")
            inizioModIn2= $("#dateboxperiodo").dxDateRangeBox("instance").option("endDate")
        },
        }).dxDateRangeBox("instance")
        const tabsIconAndText2=[
      { id: 0, text: traduzioni["guadagno_per_studente"][getLingua()]},
      { id: 1, text: traduzioni["ore_per_studente"][getLingua()]},
    ];
        $('#tabsPie').dxTabs({
      width: '100%',
      rtlEnabled: false,
      showNavButtons: false,
      selectedIndex: 0,
      dataSource: tabsIconAndText2,
      onSelectionChanged: function (e) {let  newIndex = e.component.option("selectedIndex");
        if (newIndex===-1)newIndex=0
          let tooltip
          let label
        if (newIndex===0) {
            $("#chartPie").dxPieChart("instance").option("dataSource", dataSourceGuadagno)
             tooltip= {
    enabled: true,
    customizeTooltip: function (pointInfo) {
     return {
        html: `
          <div style="padding: 5px; font-size: 14px;">
            <b>${traduzioni["categoria"][getLingua()]}:</b> ${pointInfo.argument}<br>
            <b>${traduzioni["valore"][getLingua()]}:</b> ${pointInfo.value.toLocaleString(localizzazioniNumeriche[getLingua()], { maximumFractionDigits: 2 })} € <br>
            <b>${traduzioni["percentuale"][getLingua()]}:</b> ${pointInfo.percentText}
          </div>
        `,
      };
      },
  }
  label={
      visible: true,
      connector: {
        visible: false,
      },
      customizeText: function (pointInfo) {
      return `${pointInfo.value.toLocaleString(localizzazioniNumeriche[getLingua()], { maximumFractionDigits: 2 })} €`;
    }
    }

        }
        else {
            $("#chartPie").dxPieChart("instance").option("dataSource", dataSourceOre)
            tooltip= {
    enabled: true,
    customizeTooltip: function (pointInfo) {
      return {
        html: `
          <div style="padding: 5px; font-size: 14px;">
            <b>${traduzioni["categoria"][getLingua()]}:</b> ${pointInfo.argument}<br>
            <b>${traduzioni["valore"][getLingua()]}:</b> ${pointInfo.value.toLocaleString(localizzazioniNumeriche[getLingua()], { maximumFractionDigits: 2 })} H <br>
            <b>${traduzioni["percentuale"][getLingua()]}:</b> ${pointInfo.percentText}
          </div>
        `,
      };
      },
  }
   label={
      visible: true,
      connector: {
        visible: false,
      },
      customizeText: function (pointInfo) {
      return `${pointInfo.value.toLocaleString(localizzazioniNumeriche[getLingua()], { maximumFractionDigits: 2 })} H`;
    }
    }
        }
        $("#chartPie").dxPieChart("instance").option("tooltip", tooltip)
          $("#chartPie").dxPieChart("instance").option("series.label", label)
      }
      })
        $('#tabsPie').dxTabs("instance").option("selectedIndex",0)
        $("#chartContainer").dxChart({
  dataSource: [],
  zoomAndPan: {
    argumentAxis: "both",
    valueAxis: "both"
  },
  argumentAxis: {
    argumentType: "datetime",},
  scrollBar: {
      visible: false,
    },
  series: [{
      argumentField: "date",
      valueField: "entrate",
      name: traduzioni["entrate"][getLingua()],
      type: "spline",
    },],
  tooltip: {
    enabled: true,
    customizeTooltip: function (pointInfo) {
      return {
            html:
            `<b>${traduzioni['valore'][getLingua()]}:</b> ` + `${(pointInfo.value).toLocaleString(localizzazioniNumeriche[getLingua()], { maximumFractionDigits: 2 })} €` + "<br>" +
                  `<b>${traduzioni['riferimento'][getLingua()]}: </b>` +`${DateTime.fromJSDate(pointInfo.argument).setLocale(localizzazioniDate[getLingua()]).toFormat("LLLL yyyy")}`
        };
      },
  },
  title: traduzioni["andamento_mensile"][getLingua()]
});
        $("#chartPie").dxPieChart({
  dataSource: [],

  series: {

    argumentField: "category",
    valueField: "valore",
    label: {
      visible: true,
      connector: {
        visible: false,
      },
      customizeText: function (pointInfo) {
      return `${pointInfo.value.toLocaleString(localizzazioniNumeriche[getLingua()], { maximumFractionDigits: 2 })} €`;
    }
    },
  },
  export: {
    enabled: true,
    formats: ['PNG', 'PDF', 'JPEG', 'SVG'],
    fileName: "grafico",
  },
  tooltip: {
    enabled: true,
    customizeTooltip: function (pointInfo) {
      return {
        html: `
          <div style="padding: 5px; font-size: 14px;">
            <b>${traduzioni["categoria"][getLingua()]}:</b> ${pointInfo.argument}<br>
            <b>${traduzioni["valore"][getLingua()]}:</b> ${pointInfo.value.toLocaleString(localizzazioniNumeriche[getLingua()], { maximumFractionDigits: 2 })} € <br>
            <b>${traduzioni["percentuale"][getLingua()]}:</b> ${pointInfo.percentText}
          </div>
        `,
      };}
  },
  legend: {
      visible:false,
    horizontalAlignment: "center",
    verticalAlignment: "bottom",
  },
  title: traduzioni["suddivisione_entrate"][getLingua()],
});
        const tabsIconAndText = [
      { id: 0, text: traduzioni["divisione_mensile"][getLingua()]},
      { id: 1, text: traduzioni["divisione_settimanale"][getLingua()]},
      { id: 2, text: traduzioni["divisione_giornaliera"][getLingua()]},
    ];
        $('#tabsStorico').dxTabs({
      width: '100%',
      rtlEnabled: false,
      selectedIndex: 0,
      showNavButtons: false,
      dataSource: tabsIconAndText,
      orientation: "horizontal",
      stylingMode: "primary",
      iconPosition: "top",
      onSelectionChanged: function (e) {let  newIndex = e.component.option("selectedIndex");
      if (newIndex===-1)newIndex=0
      const entrateDiv = entratePeriodi[newIndex+1];
        let total=0
        for (let i in entrateDiv){
            total+=entrateDiv[i]
        }
        let chartData = [];
        const allKeys = new Set([
          ...Object.keys(entrateDiv),
        ]);
        for (const key of allKeys) {
          let dt=null
          let jsDate=null
        if (newIndex===0)
          {dt = DateTime.fromFormat(key, "yyyy-MM", { zone: "utc" });

          jsDate = dt.toJSDate()}
        else if (newIndex===1)
        {const [year, week] = key.split("-W");
          dt = DateTime.fromObject(
          { weekYear: +year, weekNumber: +week },
          { zone: "utc" }  // oppure "none" in Luxon 3.x
        ).startOf("week")
        jsDate = dt.toJSDate()}

        else {
        dt = DateTime.fromFormat(key, "yyyy-MM-dd",{ zone: "utc" });
        jsDate = dt.toJSDate()
        }
          chartData.push({
            date: jsDate,
            entrate: entrateDiv[key] || 0,
          });
        }
        $("#chartContainer").dxChart("instance").option("dataSource",chartData)
        $("#chartContainer").dxChart("instance").option("title",newIndex===0 ? traduzioni["andamento_mensile"][getLingua()]: newIndex===1 ? traduzioni["andamento_settimanale"][getLingua()]:traduzioni["andamento_giornaliero"][getLingua()])
        let label={}
        let tooltip={}
         if (newIndex === 0) {
           label = {
            format: "monthAndYear"  // Mostra "dicembre 2024"
          };
           tooltip = {
            enabled: true,
            customizeTooltip: function (pointInfo) {
             return {
            html:
            `<b>${traduzioni['valore'][getLingua()]}:</b> ` + `${(pointInfo.value).toLocaleString(localizzazioniNumeriche[getLingua()], { maximumFractionDigits: 2 })} €` + "<br>" +
                  `<b>${traduzioni['riferimento'][getLingua()]}: </b>` +`${DateTime.fromJSDate(pointInfo.argument).setLocale(localizzazioniDate[getLingua()]).toFormat("LLLL yyyy")}`
        };
            }
          };
        }
    else if (newIndex===1){
        label= {
          customizeText: function (arg) {
            const dt = DateTime.fromJSDate(arg.value, { zone: 'utc' });
            return  `${traduzioni["settimana"][getLingua()]} ${dt.toFormat("dd/MM/yyyy")}` // Mostra "dicembre 2024"
          }
        }
        tooltip = {
            enabled: true,
            customizeTooltip: function (pointInfo) {
              return {
            html:
            `<b>${traduzioni['valore'][getLingua()]}:</b> ` + `${(pointInfo.value).toLocaleString("it-IT", { maximumFractionDigits: 2 })} €` + "<br>" +
                  `<b>${traduzioni['riferimento'][getLingua()]}: </b>` +`${traduzioni["settimana"][getLingua()]} ${DateTime.fromJSDate(pointInfo.argument,{ zone: 'utc' }).setLocale(localizzazioniDate[getLingua()]).toFormat("dd/MM/yyyy")}`
        };
            }
          };
    }
    else {
    label= {
      customizeText: function (arg) {
        const dt = DateTime.fromJSDate(arg.value, { zone: 'utc' });
        return  dt.toFormat("dd/MM/yyyy");
      }
    }
    tooltip = {
            enabled: true,
            customizeTooltip: function (pointInfo) {
              return {
            html:
            `<b>${traduzioni['valore'][getLingua()]}:</b> ` + `${(pointInfo.value).toLocaleString(localizzazioniNumeriche[getLingua()], { maximumFractionDigits: 2 })} €` + "<br>" +
                  `<b>${traduzioni['riferimento'][getLingua()]}: </b>` +`${DateTime.fromJSDate(pointInfo.argument).setLocale(localizzazioniDate[getLingua()]).toFormat("dd/MM/yyyy")}`
        };
            }
          };
    }
    $("#chartContainer").dxChart("instance").option("tooltip",tooltip)

      }
      })
         $('#tabsStorico').dxTabs("instance").option("selectedIndex",0)
        const inizioP=DateTime.fromISO(getInizioPIstr()).toFormat("yyyyMMdd")
        const fineP=DateTime.fromISO(getFinePIstr()).plus({days:1}).toFormat("yyyyMMdd")
        const fetchData=async function(){

            const lezioni=await funzione_collegamento({
                userid:getUserId(),
                token:getToken(),
                azione:"getLessonDates",
                logout_on_error:true,
                childs:["inventories"],
                filtri:{"lessondateinstructorid":parseInt(getUserId()),"lessondatesfrom":inizioP,lessondatesto:fineP,"lessondatestatus":2}
            })
            const pacchetti=await funzione_collegamento({
                userid:getUserId(),
                token:getToken(),
                azione:"getLessons",
                logout_on_error:true,
            })
            const utenti=await funzione_collegamento({
                userid:getUserId(),
                token:getToken(),
                azione:"getUsers",
                logout_on_error:true,
            })
            const periodi=await funzione_collegamento({
                userid:getUserId(),
                token:getToken(),
                azione:"getUserWorkPeriods",
                logout_on_error:true,
            })
            let pacchettiOre={}
            let pacchettiGuadagno={}
            let guadagnoTotale=0
            let oreTot=0
            entratePeriodi={1:{},2:{},3:{}}
            let utente={}
            for (let ut of utenti){
                if (ut.userid===parseInt(getUserId())) utente=ut
            }
            let periodiUt=[]
            for (let pe of periodi){
                if (pe.userid===utente.userid) periodiUt.push(pe)
            }
            for (let lezione of lezioni){
                const dataStorage=convertDate(lezione.lessondatestart)
                for (let pacchetto of pacchetti) {
                    if (pacchetto.lessonid === lezione.lessonid) {
                        const numero = pacchetto.lessonnumstudents
                        const chiaveMese=dataStorage.toFormat("yyyy-MM")
                        const chiaveGiorno=dataStorage.toISODate()
                        const chiaveSettimana=`${dataStorage.weekYear}-W${String(dataStorage.weekNumber).padStart(2, "0")}`
                        const durata = (convertDate(lezione.lessondateend) - convertDate(lezione.lessondatestart)) / (3600 * 1000)
                        let periodo=null
                        for (let period of periodiUt){
                            const inizioP=convertDate(period.workperioddatefrom)
                            let fineP=convertDate(period.workperioddateto)
                            fineP=fineP.plus({hours:23})
                            if (inizioP<=dataStorage && fineP>=dataStorage){
                                periodo=period
                            }
                        }
                        let paga = numero === 1 ? durata * (periodo.workperiodhourlypayment) : durata * (periodo.workperiodhourlypaymentgroups)
                        if (utente.type === 5 && pacchetto.lessontype === "Avanzata") {
                            let commissionLez = 0
                            if (lezione.inventories.length > 0)
                                commissionLez = periodo.workperiodcommissionratelessonmaterial / 100
                            else
                                commissionLez = periodo.workperiodcommissionratelesson / 100
                            paga = ((pacchetto.lessoncost * (1 - (pacchetto.lessondiscount || 0) / 100)) * commissionLez * durata) / pacchetto.lessonpacket
                        }
                        if (!(pacchetto.lessonstudentname in pacchettiOre))pacchettiOre[pacchetto.lessonstudentname]=0
                        if (!(pacchetto.lessonstudentname in pacchettiGuadagno))pacchettiGuadagno[pacchetto.lessonstudentname]=0
                        pacchettiGuadagno[pacchetto.lessonstudentname]+=paga
                        pacchettiOre[pacchetto.lessonstudentname]+=durata
                        if (!(chiaveMese in entratePeriodi[1]))entratePeriodi[1][chiaveMese]=0
                        entratePeriodi[1][chiaveMese]+=paga
                        if (!(chiaveGiorno in entratePeriodi[3]))entratePeriodi[3][chiaveGiorno]=0
                        entratePeriodi[3][chiaveGiorno]+=paga
                        if (!(chiaveSettimana in entratePeriodi[2]))entratePeriodi[2][chiaveSettimana]=0
                        entratePeriodi[2][chiaveSettimana]+=paga
                        guadagnoTotale+=paga
                        oreTot+=durata
                    }
                }
            }
             dataSourceOre=[]
             dataSourceGuadagno=[]
            for (let pacchetto in pacchettiOre){
                dataSourceOre.push({ category: pacchetto, valore: pacchettiOre[pacchetto] })
            }
            for (let pacchetto in pacchettiGuadagno){
                dataSourceGuadagno.push({ category: pacchetto, valore: pacchettiGuadagno[pacchetto] })
            }
            $("#chartPie").dxPieChart("instance").option("dataSource",dataSourceGuadagno)
             let chartData = [];
        const allKeys = new Set([
          ...Object.keys(entratePeriodi[1]),
        ]);
        for (const key of allKeys) {
          let dt=null
          let jsDate=null
             dt = DateTime.fromFormat(key, "yyyy-MM", { zone: "utc" });

          jsDate = dt.toJSDate()
          chartData.push({
            date: jsDate,
            entrate: entratePeriodi[1][key] || 0,
          });
        }
        $("#chartContainer").dxChart("instance").option("dataSource",chartData);
        const divCom = document.getElementById("divGen");
        divCom.innerText = `${traduzioni["guadagno_totale"][getLingua()]}: ${guadagnoTotale.toFixed(2)} €. ${traduzioni["oreTotali"][getLingua()]}: ${differenzaOrario({dataInizio:oreTot*3600*1000})}`;
    divCom.style.marginTop = "10px";
    divCom.style.fontSize = "20px";
        divCom.style.fontFamily = "Poppins, sans-serif";
        divCom.style.fontWeight = "Bold";


        }
        fetchData()
        function handleResize() {
      setIsMobile(window.innerWidth < 600);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
    },[])
return (<div>
    <h2>{traduzioni["titolo"][getLingua()]}</h2>
    <div id="dateboxperiodo"></div>
     <div id="ContainerAnalisiIstruttore"
  style={{
    display: "flex",
    gap: "15px",
    width: "100%",
    padding:"20px 0px 20px 0px",
    flexDirection: isMobile ? "column" : "row",
  }}
>
        <div  style={{flex:1, width:"100%", minWidth:0 }}>
            <div style={{ flex: 1 }} id="tabsStorico"></div>
             <div id="chartContainer" style={{flex:1, width:"100%", minWidth:0 }}></div>
        </div>
        <div  style={{flex:1, width:"100%", minWidth:0 }}>
            <div style={{ flex: 1 }} id="tabsPie" ></div>
             <div id="chartPie" style={{ flex:1,width:"100%", minWidth:0 }}></div>
        </div>


         </div>
<div id="divGen"></div>
</div>)
}
export default AnalisiIstruttore